

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./HealthChat.module.css";
import HealthChatModal from "./HealthChatModal";

// import { useState } from "react";

// export default function HealthChatBot() {
//   const [open, setOpen] = useState(false);
//   const [showTooltip, setShowTooltip] = useState(false);

//     const location = useLocation();
//   const isHomePage = location.pathname === "/";

//   /* Tooltip pulses every 5 s on home page */
//   useEffect(() => {
//     if (!isHomePage) return;
//     const interval = setInterval(() => setShowTooltip((p) => !p), 5000);
//     return () => clearInterval(interval);
//   }, [isHomePage]);

//   return (
//     <>
//       {open && <HealthChatModal onClose={() => setOpen(false)} />}

//       <div
//         className={styles.wrapper}
//         onClick={() => setOpen((p) => !p)}
//         onMouseEnter={() => setShowTooltip(true)}
//         onMouseLeave={() => setShowTooltip(false)}
//       >
//         {showTooltip && (
//           <div className={styles.tooltip}>Hi! How can I assist you?</div>
//         )}

//         <div 
//           className={styles.animatedRing}
//         >
//           <img
//             src="/images/chatbotFemCare.svg"
//             alt="Avexa AI Chatbot"
//             width={90}
//             height={90}
//             className={styles.avatar}
//           />
//         </div>
//       </div>
//     </>
//   );
// }

export default function HealthChatBot() {
  const [open, setOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  // ✅ Add/remove body class when chatbot opens/closes
  useEffect(() => {
    if (open) {
      document.body.classList.add("chatbot-open");
    } else {
      document.body.classList.remove("chatbot-open");
    }
    return () => document.body.classList.remove("chatbot-open");
  }, [open]);

  useEffect(() => {
    if (!isHomePage) return;
    const interval = setInterval(() => setShowTooltip((p) => !p), 5000);
    return () => clearInterval(interval);
  }, [isHomePage]);

  return (
    <>
      {open && <HealthChatModal onClose={() => setOpen(false)} />}
      <div
        className={styles.wrapper}
        onClick={() => setOpen((p) => !p)}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {showTooltip && (
          <div className={styles.tooltip}>Hi! How can I assist you?</div>
        )}
        <div className={styles.animatedRing}>
          <img
            src="/images/chatbot.svg"
            alt="Avexa AI Chatbot"
            width={90}
            height={90}
            className={styles.avatar}
          />
        </div>
      </div>
    </>
  );
}